import React, { useState } from 'react';
import apiService from '../services/apiService';

const TokenDebug = () => {
  const [debugInfo, setDebugInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testTokenStatus = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get('/api/debug/token');
      setDebugInfo(response.data);
      console.log('🔍 [TOKEN DEBUG] Token status:', response.data);
    } catch (err) {
      setError(`Token test failed: ${err.message}`);
      console.error('🔍 [TOKEN DEBUG] Token test failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const testTokenRefresh = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('🔄 [TOKEN DEBUG] Testing manual token refresh...');
      const response = await apiService.refreshToken();
      console.log('✅ [TOKEN DEBUG] Manual refresh successful:', response);
      
      // Test token status after refresh
      await testTokenStatus();
    } catch (err) {
      setError(`Token refresh failed: ${err.message}`);
      console.error('❌ [TOKEN DEBUG] Manual refresh failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const testHealthCheck = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get('/api/health');
      console.log('🔍 [TOKEN DEBUG] Health check:', response.data);
      setDebugInfo(prev => ({ ...prev, health: response.data }));
    } catch (err) {
      setError(`Health check failed: ${err.message}`);
      console.error('🔍 [TOKEN DEBUG] Health check failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const testApiCall = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('🔍 [TOKEN DEBUG] Testing API call that might trigger token refresh...');
      const response = await apiService.getCurrentUser();
      console.log('✅ [TOKEN DEBUG] API call successful:', response);
      setDebugInfo(prev => ({ ...prev, apiTest: 'API call successful' }));
    } catch (err) {
      setError(`API call failed: ${err.message}`);
      console.error('❌ [TOKEN DEBUG] API call failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: '10px', 
      right: '10px', 
      background: 'white', 
      border: '1px solid var(--color-border-strong)', 
      borderRadius: '8px', 
      padding: '15px', 
      maxWidth: '400px',
      fontSize: '12px',
      zIndex: 9999,
      boxShadow: '0 2px 10px var(--color-shadow-10)'
    }}>
      <h3 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>🔍 Token Debug Tool</h3>
      
      <div style={{ marginBottom: '10px' }}>
        <button onClick={testHealthCheck} disabled={loading} style={{ marginRight: '5px', fontSize: '11px' }}>
          Health Check
        </button>
        <button onClick={testTokenStatus} disabled={loading} style={{ marginRight: '5px', fontSize: '11px' }}>
          Test Token
        </button>
        <button onClick={testTokenRefresh} disabled={loading} style={{ marginRight: '5px', fontSize: '11px' }}>
          Refresh Token
        </button>
        <button onClick={testApiCall} disabled={loading} style={{ fontSize: '11px' }}>
          Test API Call
        </button>
      </div>

      {loading && <p style={{ color: 'blue', margin: '5px 0' }}>Loading...</p>}
      {error && <p style={{ color: 'red', margin: '5px 0', fontSize: '11px' }}>{error}</p>}
      
      {debugInfo && (
        <div style={{ marginTop: '10px', fontSize: '10px' }}>
          <h4 style={{ margin: '5px 0', fontSize: '12px' }}>Debug Info:</h4>
          <pre style={{ 
            background: 'var(--color-surface-hover)', 
            padding: '8px', 
            borderRadius: '4px', 
            overflow: 'auto',
            maxHeight: '200px',
            fontSize: '10px'
          }}>
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
        </div>
      )}

      <div style={{ marginTop: '10px', fontSize: '10px', color: 'var(--color-text-light)' }}>
        <p><strong>Test Instructions:</strong></p>
        <ol style={{ margin: '5px 0', paddingLeft: '15px' }}>
          <li>Click "Health Check" to see current session status</li>
          <li>Click "Test Token" to verify current token works</li>
          <li>Click "Refresh Token" to manually trigger token refresh</li>
          <li>Click "Test API Call" to test automatic refresh on 401</li>
        </ol>
      </div>
    </div>
  );
};

export default TokenDebug; 